import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import Company from '@/models/Company';
import { Pricing } from '@/models/ShareConfiguration';
import { AxiosResponse } from 'axios';

export default class ShareRepository extends EntityBaseRepository {
    public getConfiguration(): Promise<AxiosResponse> {
        return this.axiosClient.get('share');
    }

    public setShare(price: number): Promise<AxiosResponse> {
        return this.axiosClient.put('share/price-per-ride', { price });
    }

    public setIsShareActive(active: boolean): Promise<AxiosResponse> {
        return this.axiosClient.put('share/active', { active });
    }

    public setWaitingTime(minutes: number): Promise<AxiosResponse> {
        return this.axiosClient.put('share/waiting-time', { minutes });
    }

    public setPromoterRates(rates: { perDriver: number, perCustomer: number }): Promise<AxiosResponse> {
        return this.axiosClient.put('share/promoter-rates', rates);
    }

    public setPromoterIncentive(payload: {
        signupBonus: number,
        perPassengerRate: number,
        effectiveFrom?: string | null
    }): Promise<AxiosResponse> {
        return this.axiosClient.put('share/promoter-incentive', payload);
    }

    public setPricing(payload: Pricing): Promise<AxiosResponse> {
        return this.axiosClient.put('share/pricing', payload);
    }
}
